import React from "react";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import { addDays, addMonths, subDays, isLeapYear } from "date-fns";
import { DatePicker } from "@material-ui/pickers";
import { PolicyDurationId } from "../../../../helpers/additionalQuestions/policyDuration";
import Formatter from "../../../../helpers/formatter";
import { PolicyStore } from "../../../../stores/policyStore";
import Notification from "../../../sharedComponents/notification/notification";

interface InsuranceDurationProps {
  calculateStore?: CalculateStore;
  policyStore?: PolicyStore;
}

export function InsuranceDuration(props: InsuranceDurationProps) {
  const calculateStore = props.calculateStore!;
  const dateNow = new Date();
  const tomorrow = addDays(dateNow, 1);
  const minStartDate = props.policyStore!.isPolicyRenewal ? dateNow : tomorrow;
  const maxStartDate = addDays(dateNow, 60);
  const policyDuration = calculateStore.additionalQuestions.policyDuration.value;

  function onChange(date: Date | null) {
    if (date) {
      changeInsurancePeriod(date);
    }
  }

  return (
    <div className="additional-questions-section insurance-duration">
      <div className="question-answer-container">
        <div className="question">Okres ubezpieczenia</div>
        <div className="date">
          <div className="start-date">
            <DatePicker
              variant="inline"
              label="Od"
              value={getStartDate()}
              onChange={onChange}
              className="start-date-picker"
              minDate={minStartDate}
              maxDate={maxStartDate}
              format="yyyy-MM-dd"
              helperText={getErrorMessage()}
              disabled={props.policyStore!.isPolicyRenewal}
            />
          </div>
          <div className="end-date">
            <DatePicker
              disabled={true}
              className="end-date-picker"
              label="Do"
              variant="inline"
              value={policyDuration === null ? null : getEndDate()}
              onChange={() => true}
              format="yyyy-MM-dd"
            />
          </div>
        </div>
      </div>
    </div>
  );

  function getStartDate() {
    return calculateStore.additionalQuestions.startDate ? calculateStore.additionalQuestions.startDate : minStartDate;
  }

  function getEndDate() {
    return calculateEndDate(getStartDate());
  }

  function getErrorMessage() {
    if (getStartDate().setHours(0, 0, 0, 0) < minStartDate.setHours(0, 0, 0, 0)) {
      return <Notification type="error" message={<>Data nie może być wcześniejsza niż <span>{Formatter.getStringDate(new Date(minStartDate))}</span></>} />;
    } else if (getStartDate().setHours(0, 0, 0, 0) > maxStartDate.setHours(0, 0, 0, 0)) {
      return <Notification type="error" message={<>Data nie może być późniejsza niż <span>{Formatter.getStringDate(new Date(maxStartDate))}</span></>} />;
    }
    return "";
  }

  function changeInsurancePeriod(date: Date) {
    calculateStore.setStartDate(date);
  }

  function calculateEndDate(date: Date) {
    const threeYearsFromNow = addMonths(date, 36);
    const oneYearFromNow = addMonths(date, 12);
    const leapYear = isLeapYear(date) && date.getMonth() === 1 && date.getDate() === 29;
    const daysToTrim = leapYear ? 0 : 1;
    return policyDuration === PolicyDurationId.MONTHS_36 ? subDays(threeYearsFromNow, daysToTrim) : subDays(oneYearFromNow, daysToTrim);
  }
}

export default inject("calculateStore", "policyStore")(observer(InsuranceDuration));
